import { Table } from "antd";
import React, { useState } from "react";
import { useGetLookup } from "../../../api/admin";
import TableAction from "../../TableAction";

const columns = [
  {
    dataIndex: "lookupType",
    title: "Lookup Type",
    render: (_type: number) => {
      let type = "";

      switch (_type) {
        case 1:
          type = "ORGANIZATION";
          break;
        case 2:
          type = "USER";
          break;
        case 3:
          type = "GROWING_SEASON";
          break;
        case 4:
          type = "PRODUCT_TYPE";
          break;
        default:
          type = "UNKNOWN";
          break;
      }

      return <div>{type}</div>;
    },
  },
  {
    dataIndex: "lookupValue",
    title: "Lookup Value",
  },
  {
    dataIndex: "lookupDescription",
    title: "Description",
  },
];

const LookupTable = () => {
  const [searchText, setSearchText] = useState("");
  const { data: lookups, isLoading } = useGetLookup();
  return (
    <div className="flex flex-col gap-4">
      {/* <div className='flex flex-row justify-between bg-[#EEF3F8] px-8 py-4 rounded-[8.5px]'>
                <div className='text-2xl font-semibold'>Lookup</div>
            </div> */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          height: 80,
          backgroundColor: "#EEF3F8",
          borderRadius: 8.4,
          marginBottom: 12,
        }}
      >
        <TableAction setSearchText={setSearchText} />
      </div>
      <Table
        style={{
          cursor: "pointer",
          position: "relative",
          zIndex: 100,
          overflowY: "hidden",
        }}
        scroll={{ y: 600 }}
        columns={columns}
        dataSource={lookups?.data?.data || []}
      />
    </div>
  );
};

export default LookupTable;
